/**
 * Adds thumbnail photos of MPs next to their name and constituency, on email to target or tweet to target pages
 */
export const mpThumbnails = async () => {
  const mpDetails = document.querySelector('.ia-mp, .en__twitterTarget__details');

  if (mpDetails) {
    let mpName =
      mpDetails.querySelector('.ia-mp-text-name')?.textContent?.trim() ||
      document.querySelector('.en__twitterTarget__name')?.textContent?.trim() ||
      '';

    mpName = mpName
      .replace('Dr ', '')
      .replace('Mr ', '')
      .replace('Ms ', '')
      .replace('Mrs ', '')
      .replace('Miss ', '')
      .replace('Prof ', '')
      .replace('Rev ', '')
      .replace('Sir ', '')
      .replace('MP', '')
      .trim();

    const constituencyName =
      mpDetails.querySelector('.ia-mp-text-constituency')?.textContent?.trim() || '';

    const mpPhoto = document.querySelector<HTMLElement>('.ia-mp-photo, .en__twitterTarget__image');

    if (mpName && mpPhoto) {
      const dataUrl = new URL(
        'https://members-api.parliament.uk/api/Members/Search?skip=0&take=20',
      );

      dataUrl.searchParams.set('Name', mpName);
      if (constituencyName) dataUrl.searchParams.set('Location', constituencyName);

      const response = await fetch(dataUrl);
      const data = await response.json();

      if (data.items && data.items.length) {
        const mpData = data.items[0];

        if (mpData.value && mpData.value.thumbnailUrl) {
          if (mpPhoto.nodeName.toLowerCase() === 'img')
            (mpPhoto as HTMLImageElement).src = mpData.value.thumbnailUrl;
          else mpPhoto.style.backgroundImage = `url(${mpData.value.thumbnailUrl})`;

          mpPhoto.style.display = 'block';
        }
      }
    }
  }
};
